<template>
  <div class="diamond-certificate-details">
    <DefPicture :result="banner?.pictures" :property="true" />

    <div class="diamond-certificate-page">
      <div class="certificate-details-form">
        <GuaranteeCertificateField :label="messages?.barcode" :value="result['Штрихкод']" />
        <GuaranteeCertificateField :label="messages?.weight" :value="result['Вес']" />
        <GuaranteeCertificateField :label="messages?.jewelInsert" :value="result['Вставка']" />
        <GuaranteeCertificateField
          :label="messages?.jewelInsertSpecification"
          :value="result['ХарактеристикиВставки']"
        />
      </div>

      <div v-if="banner" v-html="banner.detailText" />

      <DefBarcode v-if="result['Штрихкод']" :code="result['Штрихкод']" />

      <div v-if="banner" v-html="banner.previewText" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IDiamondCertificateResponse } from '@components/Diamonds/DiamondCertificate/IDiamondCertificate';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import GuaranteeCertificateField from '@components/Cabinet/Guarantee/GuaranteeCertificateField.vue';
import DefBarcode from '@components/Def/DefBarcode/DefBarcode.vue';

const props = defineProps<{
  result: IDiamondCertificateResponse;
}>();

const resultsStore = useResultsStore();

const banner = computed(() => resultsStore.diamondCertificate?.banner);
const messages = computed(() => resultsStore.diamondCertificate?.messages);
</script>

<style lang="scss" scoped>
.diamond-certificate-details {
  :deep(.def-picture) {
    margin-bottom: 24px;
    @include point-md {
      margin-bottom: 32px;
    }
  }
}
.diamond-certificate-page {
  max-width: 424px;
  margin: 0 auto;
  padding-bottom: 40px;
  :deep(.h3) {
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    font-size: 0.875rem;
    line-height: 130%;
    margin-bottom: 16px;
    @include point-md {
      font-size: 1rem;
      line-height: 135%;
    }
  }
  :deep(ul) {
    margin-bottom: 24px;
    padding-left: 14px;
  }
  :deep(li) {
    font-weight: 500;
    font-size: 16px;
    line-height: 125%;
    margin-bottom: 8px;
    list-style-type: disc;
  }
  :deep(.def-button-primary) {
    width: 100%;
    margin-bottom: 16px;
  }
  :deep(.guarantee-certificate-message) {
    padding: 12px;
    background: #f6f6f6;
    //margin-bottom: 24px;
    p {
      font-weight: 500;
      font-size: 14px;
      line-height: 125%;
      color: #5f5f67;
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
  :deep(.guarantee-certificate-text) {
    font-size: 11px;
    line-height: 110%;
    a {
      text-decoration: underline;
      text-underline-position: under;
    }
  }
  :deep(.def-barcode) {
    display: block;
    margin: 0 auto 16px;
  }
}
.certificate-details-form {
  display: grid;
  grid-gap: 8px 16px;
  margin-bottom: 24px;
  //@include point-md{
  grid-template-columns: repeat(2, 1fr);
  //}

  & > * {
    &:nth-child(1n + 7) {
      @include point-md {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
  }
}
</style>
